import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const url = process.env.REACT_APP_API_URL;
  const [profile, setProfile] = useState({});

  const handleNavigation = (path) => {
    navigate(path);
  };

  const fetchUserData = async () => {
    try {
      const profileRes = await fetch(
        `${url}/register/single/${process.env.REACT_APP_PERFUME_ID}`
      );
      const res = await profileRes.json();
      setProfile(res.users);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo & About */}
        <div className="footer-section">
          <h2 className="footer-logo">
            {profile?.profilePic ? (
              <img
                className="footer-logo-img"
                src={`${url}/uploads/profile/${profile.profilePic}`}
                alt="Cycle Rental Services"
              />
            ) : (
              profile?.orignal_logoname || "Oza Clothing Company"
            )}
          </h2>
          <p>
            Cycle Rental Service – Your trusted destination for cycle rentals.
          </p>
          {/* <div className="social-icons">
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.facebook.com" target="_blank" rel="noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://www.youtube.com" target="_blank" rel="noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
          </div> */}
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li onClick={() => handleNavigation("/home")}>Home</li>
            <li onClick={() => handleNavigation("/products")}>Cycle On Rent</li>
            <li onClick={() => handleNavigation("/cycle-service")}>Cycle Service</li>
            <li onClick={() => handleNavigation("/invite-us")}>Invite Us</li>
            <li onClick={() => handleNavigation("/about")}>Our Story</li>
            <li onClick={() => handleNavigation("/PartnerWithUs")}>Partner With Us</li>
            <li onClick={() => handleNavigation("/contact")}>Contact Us</li>
          </ul>
        </div>

        {/* Customer Service */}
        <div className="footer-section">
          <h3>Customer Service</h3>
          <ul>
            <li onClick={() => handleNavigation("/refund-policy")}>
              Refund Policy
            </li>
            <li onClick={() => handleNavigation("/privacy-policy")}>
              Privacy Policy
            </li>
            <li onClick={() => handleNavigation("/shipping-and-delivery")}>
              Shipping Policy
            </li>
            <li onClick={() => handleNavigation("/terms-and-conditions")}>
              Terms & Conditions
            </li>
            <li onClick={() => handleNavigation("/faqs")}>
              FAQ
            </li>
            {/*<li onClick={() => handleNavigation("/enquiry-form")}>Enquiry</li>*/}
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Contact Info</h3>
          <p>
            <strong>Phone:</strong> 8082080816
          </p>
          <p>
            <strong>Email:</strong> info@cyclerentalservices.com
          </p>
          <p>
            <strong>Address:</strong>
          </p>
          <ul>
            <li>
              Mumbai, MH - 400101, India
            </li>
          </ul>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} <a href="https://100billiontech.com/ownership" target="_blank"
          rel="noreferrer">copy-rights reserved</a>, Designed by <a href="https://100billiontech.com/" target="_blank"
            rel="noreferrer">100billion Tech</a></p>
      </div>
    </footer>
  );
};

export default Footer;
